jQuery(document).ready(function (e) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  // const para = urlParams.get("para");
  const para = urlParams.get("r") || urlParams.get("para");
  const decodedString = atob(para);
  const decodedStringArr = decodedString.split("|");
  const referral_num = decodedStringArr[0];

  jQuery(".suburb").text(decodedStringArr[3]);
  jQuery(".lead-number").text(referral_num);
  if (!queryString || decodedStringArr[3] == undefined) {
    console.log(queryString, decodedStringArr);
    jQuery(".accept-lead").removeClass("active");
    jQuery(".lead-box").hide();
    jQuery(".sms-details").addClass("active");
    jQuery(".not-valids").addClass("active");
  } else if (decodedStringArr[1] == "Y") {
    jQuery(".accepted-lead").addClass("active");

    var settings = {
      url: "https://webhooks.au.workato.com/webhooks/rest/a5c1f3b4-4735-478a-a145-5c9778130b34/lrack",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        referral_num: referral_num,
        referral_response: "Y",
      }),
    };
    callWorkatoAJAX(settings, "Y");
  } else if (decodedStringArr[1] == "N") {
    jQuery(".declined-lead").addClass("active");

    var settings = {
      url: "https://webhooks.au.workato.com/webhooks/rest/a5c1f3b4-4735-478a-a145-5c9778130b34/lrack",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        referral_num: referral_num,
        referral_response: "N",
      }),
    };
    callWorkatoAJAX(settings, "N");
  }

  jQuery(".accepted-lead-btn").click(function (e) {
    e.preventDefault();

    jQuery(".sms-details").addClass("active");
    jQuery(".accept-lead").removeClass("active");
    jQuery(".accepted-lead").addClass("active");

    var settings = {
      url: "https://webhooks.au.workato.com/webhooks/rest/a5c1f3b4-4735-478a-a145-5c9778130b34/lrack",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        referral_num: referral_num,
        referral_response: "Y",
      }),
    };
    callWorkatoAJAX(settings, "Y", "SMS");
  });

  jQuery(".declined-lead-btn").click(function (e) {
    e.preventDefault();

    jQuery(".sms-details").addClass("active");
    jQuery(".accept-lead").removeClass("active");
    jQuery(".accepted-lead").removeClass("active");
    jQuery(".declined-lead").addClass("active");

    var settings = {
      url: "https://webhooks.au.workato.com/webhooks/rest/a5c1f3b4-4735-478a-a145-5c9778130b34/lrack",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        referral_num: referral_num,
        referral_response: "N",
      }),
    };
    callWorkatoAJAX(settings, "N", "SMS");
  });
});

function callWorkatoAJAX(settings, action, channel = "Email") {
  $.ajax(settings)
    .done(function (response) {
      console.log("Done");
      if (response.status == "ok") {
        console.log("response.status OK");
        console.log(response, response.status, action);
        if (action == "Y") {
          jQuery(".accepted-lead-msg").addClass("active");
        } else {
          jQuery(".declined-lead-msg").addClass("active");
        }
      } else {
        console.log("response.status ELSE");
        jQuery(".workato-error").addClass("active");
      }
    })
    .fail(function () {
      jQuery(".workato-error").addClass("active");
      console.log("Faild");
      console.log(settings);
      var formData = {};
      const data = JSON.parse(settings.data);
      formData["Referral Number"] = data.referral_num;
      formData["Response"] = data.referral_response;
      formData["Channel"] = channel;
      formData["Status"] = "Queued";

      var fields = ["Referral Number", "Response", "Channel"];
      formData.formDataNameOrder = JSON.stringify(fields);
      formData.formGoogleSheetName = "01. Response Queue"; // default sheet name
      callSpreadSheetsAJAX(formData);
    });
}

function callSpreadSheetsAJAX(data) {
  /* Save sheet lead URL => https://docs.google.com/spreadsheets/d/1xkHawIYdPcIvg30WGW3vx_UThxTakaf52VwuiziSs_E/edit?gid=0#gid=0 */
  var url =
    "https://script.google.com/macros/s/AKfycbxl7ib2B-86lVGDoOp1Qe_BUkiI46S7UVYJfQzUtgo055XauuOB-OV4-W0r3wcd-R9l5A/exec";
  var xhr = new XMLHttpRequest();
  xhr.open("POST", url);
  // xhr.withCredentials = true;
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.onreadystatechange = function () {
    console.log(xhr.readyState, xhr.status);
    if (xhr.readyState === 4 && xhr.status === 200) {
      // form.reset();
    }
  };
  console.log(data);
  // url encode form data for sending as post data
  var encoded = Object.keys(data)
    .map(function (k) {
      return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
    })
    .join("&");
  xhr.send(encoded);
}
